/**
 * This file is part of Shuup.
 *
 * Copyright (c) 2012-2020, Shoop Commerce Ltd. All rights reserved.
 *
 * This source code is licensed under the OSL-3.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
  
function ensureNumericValue(value, defaultValue = 0, asInteger = false) {
    if (!isNumeric(value)) {
        return defaultValue || 0;
    }
    if (Number.isInteger(value) || asInteger) {
        return parseInt(value, 10);
    }
    return parseFloat(value);
}

window.updatePrice = function updatePrice(productId, productVariationId, popup=false, updateVariation=false, quantityValue) {
    productVariationId = productVariationId || productId;

    const quantityId = "#product-quantity-" + productId;
    var $quantity = $(quantityId);
    var quantity = 1;

    if (quantityValue != undefined) {
        quantity = quantityValue;
        $quantity.val(quantity);
    } else {
        quantity = ensureNumericValue($quantity.val(), quantity);
        quantity = Math.max(quantity, $quantity.data().min);
        $quantity.val(quantity.toFixed($quantity.data('decimals')));
    }

    var data = {
        // In case productId is not available try to fallback to first input with correct name
        id: productId ? productId : $("input[name=product_id]").val(),
        quantity: $quantity.val(),
        unitType: $("#product-unit-type-" + productId).val(),
        popup: popup,
    };

    const $supplier = $("#product-supplier-" + productId);
    if ($supplier.length > 0) {
        data.supplier = $supplier.val();
    }

    var $simpleVariationSelect = $("#product-variations-" + productVariationId);
    if ($simpleVariationSelect.length > 0) {
        // Smells like a simple variation; use the selected child's ID instead.
        data.id = $simpleVariationSelect.val();
    } else {
        // See if we have variable variation select boxes; if we do, add those.
        $("select.variable-variation-" + productId).serializeArray().forEach(function(obj) {
            data[obj.name] = obj.value;
        });
    }
    jQuery.ajax({url: "/xtheme/product_price", dataType: "html", data: data}).done(function(responseText) {
        const $content = $("<div>").append($.parseHTML(responseText));
        const priceDiv = "#product-price-div-" + productId;

        if ($content.find("[id^='no-price']").length > 0) {
            $("#add-to-cart-button-" + productId).prop("disabled", true).not('.hidden').addClass('hidden');
        } else {
            $("#add-to-cart-button-" + productId).not(".not-orderable").prop("disabled", false).removeClass('hidden');
        }

        $(priceDiv).replaceWith($content.find(priceDiv));

        if (productVariationId && updateVariation) {
            // Variation children
            const swiper = $('.swiper-product-container')[0] && $('.swiper-product-container')[0].swiper;
            const primaryImage = $('.primary-image-' + productVariationId);
            const primaryImageIndex = primaryImage.index();
            const variationProductSku = $('label#variation-product-sku-' + productVariationId);
            const $newQuantity = $content.find(quantityId);

            $quantity
                .attr('step', $newQuantity.attr('step'))
                .attr('min', $newQuantity.attr('min'))
                .attr('onchange', 'updatePrice(' + productId + ',' + productVariationId + ')');
            $quantity.data($newQuantity.data());
            
            $('#product-price-section input[name=product_img]').val(primaryImage.find('img').attr('src'));

            if (swiper && primaryImageIndex >= 0) {
                swiper.slideToLoop(primaryImageIndex - 1);
            }

            $('.product-sku').html(variationProductSku.html());
        }
    });
};
